import { FormHelperText, styled } from '@mui/material';

export const StyledFormHelperText = styled(FormHelperText)(({ theme }) => ({
  color: theme.palette.lwDanger[100],
  position: 'relative',
}));
